import { Outlet } from '@remix-run/react'

export default function PublicLayout() {
	return (
		<div>
			<main className="py-10">
				<div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
					<Outlet />
				</div>
			</main>
		</div>
	)
}
